import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { setWidth, lazyLoadSeriesDates, calendarView } from '../actions/event-series';
import { getNumberOfMonths,
    getFormattedStartMonth,
    getFormattedEndMonth,
    getDisabledDates,
    getFormattedSoldOutDates,
    getFormattedEventDates,
    getCalendarColors,
    seriesHasSchedule,
    getCurrentMonth,
    needsDatesLoaded
} from '../selectors/eventSeries';
import { createLoadingSelector } from 'checkout/selectors/helpers';
import DayPicker from './DayPicker';
import { hasHookSubscription } from '@b/checkout/selectors/hooks';

/**
 * Wrapper that connects DayPicker to redux
 */
class SeriesDayPicker extends Component {

    constructor(props) {
        super(props);

        this.state = {
            isCalendarViewReported: false,
        }
    }

    componentDidMount = () => {
        this.updateDimensions();
        window.addEventListener("resize", this.updateDimensions);
        if (needsDatesLoaded(this.props)) {
            this.props.lazyLoadSeriesDates(this.props.currentMonth);
        }
    }

    componentDidUpdate() {
      if (!this.state.isCalendarViewReported && this.props.hasCalendarViewSubscription) {
        this.setState({ isCalendarViewReported: true });
        this.props.calendarView({
          numberOfMonths: this.props.numberOfMonths,
          month: this.props.month,
        });
      }
    }

    updateDimensions = () => {
        this.props.setWidth(window.innerWidth);
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.updateDimensions);
    }

    render() {

        if (!this.props.hasSchedule) {
            return null;
        }

        return (
            <DayPicker {...this.props} />
        );
    }
};

SeriesDayPicker.propTypes = {
    locale: PropTypes.string.isRequired,
    selectedDay: PropTypes.string,
    startingMonth: PropTypes.instanceOf(Date),
    endingMonth: PropTypes.instanceOf(Date),
    selectedDays: PropTypes.array.isRequired,
    disabled: PropTypes.array,
    onDayClick: PropTypes.func.isRequired,
    onMonthChange: PropTypes.func.isRequired,
};

const calendarLoading = createLoadingSelector("SERIES_CALENDAR");
const inventoryFilterLoading = createLoadingSelector("INVENTORY_FILTER");
const mapStateToProps = (state) => {
    // all kinds of things crash here if the series does not have a schedule
    let hasSchedule = seriesHasSchedule(state);

    if (!hasSchedule) {
        return {
            locale: state.intl.locale,
            selectedDays: [],
            hasSchedule,
        };
    }

    return {
        locale: state.intl.locale,
        numberOfMonths: getNumberOfMonths(state),
        startMonth: getFormattedStartMonth(state),
        defaultMonth: getFormattedStartMonth(state),
        endMonth: getFormattedEndMonth(state),
        disabled: getDisabledDates(state),
        soldOutDays: getFormattedSoldOutDates(state),
        eventDates: getFormattedEventDates(state),
        calendarColors: getCalendarColors(state),
        selectedDays: getFormattedEventDates(state),
        accentColor: state.ui.styleVars.GLOBAL__COLOR__ACCENT,
        loading: calendarLoading(state),
        fullLoading: inventoryFilterLoading(state),
        month: getCurrentMonth(state),
        needsDatesLoaded: needsDatesLoaded(state),
        loadedDates: state.eventSeries.datesLazyLoaded,
        hasSchedule,
        inventoryFilterResults: state.inventoryFilter.filterResults,
        hasCalendarViewSubscription: hasHookSubscription(state, 'ADD_CALENDAR_VIEW_HOOK'),
    };
};

const mapDispatchToProps = dispatch => {
    return bindActionCreators({
        lazyLoadSeriesDates,
        setWidth,
        calendarView,
    }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(SeriesDayPicker);
